<div class="p-d-flex p-flex-column section feedback">
  <div class="header">
    <div class="p-d-flex p-flex-row p-ai-center title">
      <div class="circle p-d-none p-d-md-block secondary">•</div>
      <span class="comment-title desktop-view">
        Отзывы
      </span>
      <span class="comment-title mobile-view">
        Комментарии
        <span class="comment-count">
        {{totalCount}}
      </span>
      </span>
    </div>
  </div>
  <div class="mobile-view">
    <div class="controls">
      <button [disabled]="pageNumber === 0" (click)="prevReview()">
        <img src="assets/images/arrow-left.svg" alt="prev-review">
      </button>
      <button [disabled]="totalCount === (pageNumber + 1)" (click)="nextReview()">
        <img src="assets/images/arrow-right.svg" alt="next-review">
      </button>
    </div>
  </div>
  <div class="body">
    <ng-template #loading>
      <app-ns-spinner></app-ns-spinner>
    </ng-template>
    <ng-container *ngIf="agentFeedback$ | async as feedback; else loading">
      <ng-container *ngIf="feedback.length">
        <ng-container *ngFor="let item of feedback">
          <div class="desktop-view">
            <div class="text">
              {{item.comment}}
            </div>
            <div class="p-d-flex p-jc-between client-info">
            <span>
              {{item.clientName}} {{item.clientSurname}}
            </span>
              <div class="controls">
                <button [disabled]="pageNumber === 0" (click)="prevReview()">
                  <img src="assets/images/arrow-left.svg" alt="prev-review">
                </button>
                <button [disabled]="totalCount === (pageNumber + 1)" (click)="nextReview()">
                  <img src="assets/images/arrow-right.svg" alt="next-review">
                </button>
              </div>
            </div>
          </div>
          <div class="mobile-view">
            <div class="text">
              {{item.comment}}
            </div>
            <div class="p-d-flex p-jc-between client-info">
              <span>
                {{item.clientName}} {{item.clientSurname}}
              </span>
              <span class="date">{{item.createdDate | date: 'dd.mm.yyyy'}}</span>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="feedback.length === 0">
        <div class="no-data">
          Нет отзывов
        </div>
      </ng-container>

    </ng-container>
  </div>
</div>
